module.exports = __webpack_public_path__ + "static/img/全息成像1.4c902d53.png";